export default "__VITE_ASSET__CUYUSeAq__"